import { Button, Col, DatePicker, Form, Modal, Row } from 'antd';
import { Moment } from 'moment';
import { FC } from 'react';
import { RiCloseFill } from 'react-icons/ri';

export type Range = { start: Date; end: Date };
export interface Props {
  handleCancel: () => void;
  handleSubmit: (range: Range) => void;
  title: string;
}

export const RangeForm: FC<Props> = (props) => {
  const [form] = Form.useForm();
  type FormModel = { range: [startDate: Moment, endDate: Moment] };

  function internalOnSubmit(values: FormModel) {
    const range: Range = {
      start: values.range[0].toDate(),
      end: values.range[1].toDate(),
    };

    props.handleSubmit(range);
  }
  return (
    <Modal
      title={<h5 className='hp-mb-0'>{props.title}</h5>}
      width={416}
      open={true}
      onCancel={props.handleCancel}
      footer={<></>}
      closeIcon={
        <RiCloseFill
          className='remix-icon hp-text-color-black-100 hp-text-color-dark-0'
          size={24}
        />
      }
    >
      <Form
        onFinish={internalOnSubmit}
        form={form}
        layout='vertical'
        name='basic'
        initialValues={{}}
      >
        <Form.Item required label='Período' name='range'>
          <DatePicker.RangePicker />
        </Form.Item>

        <Row>
          <Col md={12} span={24} className='hp-pr-sm-0 hp-pr-12'>
            <Button block type='primary' htmlType='submit'>
              Confirmar
            </Button>
          </Col>

          <Col md={12} span={24} className='hp-mt-sm-12 hp-pl-sm-0 hp-pl-12'>
            <Button block onClick={props.handleCancel}>
              Cancelar
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
